import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import ItemCategory from "../../../containers/modules/master/item-category";

export default function ItemCategoryRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="item-category"
      index
      element={
        <AccessControl
          name={"Item Category List"}
          auth={authUser}
          component={() => <ItemCategory authUser={authUser}></ItemCategory>}
        />
      }
    />
  );
}
